<template>
  <div class="mainCon">
    <stu-main-title></stu-main-title>
    <div class="content">

      <div class="sign-bottom" v-if="true" >
        <div class="sign-bottom-top">
        </div>
        <div class="sign-bottom-main">
          <h1>{{noticeInfo.title}}</h1>
          <p v-html="noticeInfo.content" class="returnP"></p>
        </div>
      </div>

      <div v-else class="noScore">
        <img src="@/assets/stuImg/nothing.png" alt="" />
        <span class="col_grayQ">暂无公告，请等待</span>
      </div>
    </div>
  </div>
</template>
<script>
import { selectNoticeByIdInfo } from "@/http/modules/student/notice";
export default {
  name: "stuNotice",
  data() {
    return {
      // 公告详情
      noticeInfo: "",
    };
  },
  mounted(){
    this.NoticeInfo();
  },
  methods: {
    /*********************************
     * @this 公告详情页面
     *********************************/
    async NoticeInfo(){
      let id = this.$route.query.id;
      let params = { 
        id,
        isFrom:"00"
      }
      const{ data } = await selectNoticeByIdInfo(params);
      this.noticeInfo = data;
    },
  }
};
</script>
<style lang="less" scoped>
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  min-width: 700pt;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    .noScore {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 80px;
    }
  }
}
/deep/ .el-table th,
.el-table tr {
  background-color: #ebecff !important;
}

/* ***** 院校公告 ***** */
.sign-bottom {
  width: 100%;
  min-height: 430px;
  border-radius: 8px;
  background-color: #fff;
  margin-top: 24px;
  padding: 30px 40px;
  box-sizing: border-box;
  .sign-bottom-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    span{
      font-size:18px;
      color : #2D2F33;
      font-weight: 600;
    }
    a{
      text-decoration: none;
      color: #737780;
      font-size: 14px;
    }
  }
  .sign-bottom-main{
    .returnP {
      width:100%;
      word-break: break-all;
      word-wrap: break-word;
    }
    h1 {
      text-align: center;
    }
    p {
      margin-top:16px;
      text-indent: 2rem;
      font-size: 18px;
      color : #333;
    }
  }
}
</style>